import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Funcionario } from '../models/funcionario';
import { Filtro } from '../models/filtro';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { FuncionarioService } from '../services/funcionario.service';
import { UtilitarioService } from '../services/utilitario.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from '../services/global.service';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import swal from 'sweetalert2';
import { Location, PlatformLocation } from '@angular/common';
import { AutenticacaoService } from '../services/autenticacao.service';
import { TipoDeLogin } from '../models/enum';
import { MonitoramentoFuncionarioModalComponent } from './../modals/monitoramento-funcionario-modal/monitoramento-funcionario-modal.component';
import { PerfilService } from '../services/perfil.service';
import { PaginatorService } from '../services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-funcionario',
  templateUrl: './funcionario.component.html',
  styleUrls: ['./funcionario.component.scss']
})
export class FuncionarioComponent implements OnInit, OnDestroy {

  // variáveis
  funcionariosFiltrados: Funcionario[] = [];
  carregando = true;
  campoOrdenacao = 'nome';
  ordenarDesc = false;
  editavel = true;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  status = [{ id: null, nome: 'Todos' }, { id: true, nome: 'Ativo' }, { id: false, nome: 'Bloqueado' }];
  statusSelecionado = true;
  administrador = false;

  perfisDeAcesso = [];
  perfilDeAcessoSelecionado;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(private funcionarioService: FuncionarioService, public utilitarioService: UtilitarioService,
    private router: Router, private globalService: GlobalService, private paginatorService: PaginatorService,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService,
    private autenticacaoService: AutenticacaoService, private platformLocation: PlatformLocation,
    public dialog: MatDialog, private route: ActivatedRoute, private perfilService: PerfilService) { }

  async ngOnInit() {
    this.administrador = await this.globalService.administrador();
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarPerfisDeAcesso();
    this.buscarFuncionarios();
  }

  buscarPerfisDeAcesso() {
    this.carregandoService.mostra('buscarPerfisDeAcesso');

    this.perfilService.consultarPerfis().subscribe(
      (perfisDeAcesso) => {
        this.perfisDeAcesso = perfisDeAcesso;
        this.carregandoService.esconde('buscarPerfisDeAcesso');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPerfisDeAcesso');
        this.notificacaoService.erro(erro);
      }
    );
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarFuncionarios();
    this.paginator.firstPage();
  }

  buscarFuncionarios() {
    this.carregandoService.mostra('buscaFuncionarios');

    this.funcionarioService.consultarFuncionariosComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.statusSelecionado, false, this.perfilDeAcessoSelecionado).subscribe(dados => {
      this.funcionariosFiltrados = dados.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;

      this.carregando = false;
      this.carregandoService.esconde('buscaFuncionarios');
    }, (erro) => {
      this.carregandoService.esconde('buscaFuncionarios');
      this.notificacaoService.erro(erro);
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarFuncionarios();
  }

  retornaPerfil(perfil) {
    switch (perfil) {
    case 1:
      return 'Op';

    case 2:
      return 'Ad';

    default:
      break;
    }
  }

  retornaClassePerfil(perfil) {
    switch (perfil) {
    case 1:
      return 'badge-primary';

    case 2:
      return 'badge-info';

    default:
      break;
    }
  }

  liberarAcesso(funcinario: Funcionario, reenvio?: boolean) {
    swal({
      title: 'Atenção!!',
      text: reenvio ? 'Deseja reenviar o email para liberar o acesso a esse usuário?' : 'Deseja realmente liberar o acesso para esse usuário?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('liberaSenha');

        const url = location.origin + this.platformLocation.getBaseHrefFromDOM();

        this.autenticacaoService.liberarAcesso(TipoDeLogin.Vendedor, funcinario.idFuncion,url).subscribe(resp => {
          this.carregandoService.esconde('liberaSenha');
          swal(
            {
              title: 'Sucesso!',
              text: reenvio ? 'Email Reenviado!' : 'Acesso Liberado!',
              type: 'success',
              confirmButtonClass: 'btn btn-info',
              buttonsStyling: false
            }
          ).then(() => {
            this.filtra();
          });

        }, (erro) => {
          this.carregandoService.esconde('liberaSenha');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  bloquearAcesso(funcinario: Funcionario) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente bloquear o acesso desse usuário?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('bloquearSenha');

        this.autenticacaoService.bloquearAcessoVendedor(funcinario.idFuncion).subscribe(resp => {
          this.carregandoService.esconde('bloquearSenha');
          swal(
            {
              title: 'Sucesso!',
              text: 'Acesso Bloqueado!',
              type: 'success',
              confirmButtonClass: 'btn btn-info',
              buttonsStyling: false
            }
          ).then(() => {
            this.filtra();
          });

        }, (erro) => {
          this.carregandoService.esconde('bloquearSenha');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  abrirMonitoramentos(idFuncionario) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(MonitoramentoFuncionarioModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { idFuncionario: idFuncionario },
      panelClass: 'modal-card'
    });
  }

  ngOnDestroy(): void {}

  novoFuncionario() {
    this.router.navigate(['novo'], { relativeTo: this.route });
  }

  editarFuncionario(funcionario: Funcionario) {
    this.router.navigate(['editar', funcionario.idFuncion], { relativeTo: this.route });
  }

  bloquearFuncionario(funcionario: Funcionario) {

    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente bloquear o Usuário?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('bloquearFuncionario');
        this.funcionarioService.bloquear(funcionario.idFuncion).subscribe(resp => {

          this.notificacaoService.sucesso('Usuário bloqueado com sucesso!!!');
          this.carregandoService.esconde('bloquearFuncionario');
          this.filtra();

        }, (erro) => {
          this.carregandoService.esconde('bloquearFuncionario');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }
}
